import React from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';
import { useAppSelector } from '@store/index';
import { selectUser } from '@features/auth/authSlice';
import { isDisplayableLabel } from '@utils/labels';
import SettingsGroup from './SettingsGroup';
import DetailRow from './DetailRow';

const ProfileTab: React.FC = () => {
  const { t } = useTranslation();
  const user = useAppSelector(selectUser);

  // Group membership comes back as ids for some tenants; an id is not a label.
  const displayableGroups = (user?.groups ?? []).filter(isDisplayableLabel);

  if (!user) return null;

  return (
    <SettingsGroup
      boxAs="dl"
      title={t('profile.userInfo')}
      description={t('settings.profileDescription')}
    >
      <DetailRow label={t('profile.name')}>{user.fullName || '—'}</DetailRow>
      <DetailRow label={t('profile.email')}>{user.email}</DetailRow>
      <DetailRow label={t('profile.role')}>
        <Badge variant="secondary" className="font-normal">
          {user.role}
        </Badge>
      </DetailRow>
      <DetailRow label={t('profile.tenant')}>{user.tenantCode || '—'}</DetailRow>
      {displayableGroups.length > 0 && (
        <DetailRow label={t('profile.groups')}>
          <span className="flex flex-wrap gap-1">
            {displayableGroups.map((group) => (
              <Badge key={group} variant="outline" className="font-normal">
                {group}
              </Badge>
            ))}
          </span>
        </DetailRow>
      )}
    </SettingsGroup>
  );
};

export default ProfileTab;
